/** All possible form types supported by the voice assistant */
export enum VoiceAssistantFormEnum {
  /** Contragent create or update form */
  CONTRAGENT = 'CONTRAGENT',
  /** Client create or update form */
  CLIENT = 'CLIENT',
  /** HD task type create or update form */
  HD_TASK_TYPE = 'HD_TASK_TYPE',
  /** Contract create or update form */
  CONTRACT = 'CONTRACT',
}
